import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isResetOpen: false,
};

const resetToggleSlice = createSlice({
  name: "resetToggle",
  initialState,
  reducers: {
    toggleReset: (state, action) => {
      // state.isResetOpen = !state.isResetOpen; 
      // if(state.isResetOpen === true){
      //   console.log('open')
      // }else{
      //   console.log('off')
      // }
      state.isResetOpen = action.payload;
    },
  },
});


export const { toggleReset } = resetToggleSlice.actions;
export const selectIsResetOpen = (state) => state.resetToggle.isResetOpen;

export default resetToggleSlice.reducer;
